<template>
    <div class="line-loader"></div>
</template>

<script>
export default {
  name: 'lineLoader',
};
</script>

<style scoped lang="scss">
    .line-loader {
        overflow: hidden;
        margin-top: -2px;

        &::after {
            display: block;
            background-color: #ffcc00;
            content: '';
            height: 2px;
            width: 0;
            left: 0;
            animation: loading infinite 1.8s ease;
        }
    }

    @keyframes loading {
        0% {
            width: 0;
            transform: translate(0, 0);
        }

        100% {
            width: 100%;
            transform: translate(100%, 0);
        }
    }
</style>
